module.exports = __webpack_public_path__ + "static/media/emojis_20.a286a759.svg";